import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {exibirMensagemErro, xfetch, HttpVerbo, USUARIO} from "../util";
import {Carregando} from "../componentes";
import {setWindowClass} from "../util/helper";
import logoLogin from "../img/png/logo_login.png";
import {IconFingerprint} from '@tabler/icons-react';
import {setToken} from '../util/storage-util';

export default function Login() {
    const [objeto, setObjeto] = useState({
        email: '',
        senha: '',
    })
    const [isCarregando, setIsCarregando] = useState(false);
    const [searchParams, setSearchParams] = useSearchParams();
    const url = searchParams.get("url");
    function enviar(e: any) {
        e.preventDefault()
        setIsCarregando(true)
        const dados = {
            email: objeto.email,
            senha: objeto.senha
        }

        xfetch('/login', dados, HttpVerbo.POST)
            .then(res => res.json())
            .then(json => {
                localStorage.setItem(USUARIO, JSON.stringify(json.usuario))
                setToken(json.token)
                if (url == null) window.location.assign("/principal")
                else window.location.assign(url)

            })
            .catch(e => {
                console.log(e)
                exibirMensagemErro("Usuário ou senha inválidos.")
            })
          .finally(() => setIsCarregando(false))
    }

    useEffect(() => {
        setWindowClass('hold-transition login-page');
    })
    return (
        <div className="login-box">
            <Carregando ativo={isCarregando}/>
            <div className="card card-outline card-primary">
                <div className="card-header text-center">
                    <img src={logoLogin}  alt={"logo asplan"}/>
                </div>
                <div className="card-body">
                    <p className="login-box-msg">Entre com seu email funcional e sua senha do expresso.</p>
                    <form className="row g-3 needs-validation" noValidate>

                        <div className="col-12">
                            <label htmlFor="yourUsername" className="form-label mb-n2">Email expresso</label>
                            <div className="input-group has-validation">
                                <span className="input-group-text" id="inputGroupPrepend">@</span>
                                <input type="text" name="email"
                                       className="form-control" id="yourUsername" required
                                       value={objeto.email}
                                       onChange={(e) => setObjeto({...objeto, email: e.target.value})}/>
                                <div className="invalid-feedback">Insira seu email funcional</div>
                            </div>
                        </div>

                        <div className="col-12 mt-3">
                            <label htmlFor="yourPassword" className="form-label mb-n2">Senha</label>
                            <div className="input-group">
                                <span className="input-group-text" id="inputGroupPrepend"><i className="bi bi-lock-fill"></i></span>
                                <input
                                  type="password" name="senha"
                                  className="form-control" id="yourPassword" required
                                  value={objeto.senha}
                                  onChange={(e) => setObjeto({...objeto, senha: e.target.value})}/>
                                <div className="invalid-feedback">Insira sua senha do expresso</div>
                            </div>
                        </div>

                        <div className="col-12 mt-5">
                            <button className="btn btn-primary w-100" onClick={enviar}><IconFingerprint />Entrar</button>
                        </div>
                    </form>
                    <div className="mt-5 text-center">
                        Coordenação de Inovação e Tecnologia<br />ASPLAN - SSP - SE
                    </div>
                </div>

            </div>
        </div>
    );
}